// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"2a6e4a95","453":"125852ca"}[chunkId] + ".chunk.js";
};